import { USER_REVENUECAT_ID } from "../../constants/global";
import Cookies from "js-cookie";
import { getHostedDomain } from "../getHostedDomain";

export const setUserRevenueCatId = (token: string): string | undefined =>
  Cookies.set(USER_REVENUECAT_ID, token, { domain: getHostedDomain() });
